import { PERMISSIONS } from '@globalConstants';
import useUser from './useUser';
type permissionstype = keyof typeof PERMISSIONS;
/**
 * Verifies if a user's token contains the required permissions
 * @param {string[]} requiredPermissions - The array of permissions to check against.
 * @returns {boolean} - Returns true if all required permissions are present, otherwise false.
 */
function usePermissionUtil() {
  const { user } = useUser();
  /**
   * function to verify if the user has the required permissions
   * @param requiredPermissions permissions to check against the user's permissions
   */
  const canAccess = (requiredPermissions: permissionstype[]) =>
    requiredPermissions.some((value) => user?.permissions.includes(value));
  return { canAccess };
}
export default usePermissionUtil;
